export default {
  'Choose File': 'Выбрать файл',
  'Please paste a URL': 'Введите URL-ссылку на видео',
  'Loading': 'Загрузка',
  'Analyzing': 'Загружается',
  'Try a sample': 'Попробуйте пример',
  'Sorry, error occurs when analyzing the URL.': 'Извините, произошла ошибка при разборе URL-адресов.',
}